import React from 'react';
import { connect } from 'react-redux';
import { newCohortFromDataset } from '@/cohorts/actions';
import { showDatasetConditions } from '@/datasets/conditions/actions';
import SearchResultCardItem from '../components/SearchResultCardItem';

const SearchresultCardItems = ({
  accessRequestAllowed,
  cohortAllowed,
  compact,
  items,
  newCohort,
  newCohortCode,
  newRequestCode,
  showConditions,
}) => (
  items.map((item) => (
    <SearchResultCardItem
      accessRequestAllowed={accessRequestAllowed}
      accessRequestSupported={item.requestEnabled?.supported}
      accessRequestUnsupportedReasons={item.requestEnabled?.reasons}
      code={item.code}
      cohortAllowed={cohortAllowed}
      cohortSupported={item.queryEnabled?.supported}
      cohortUnsupportedReasons={item.queryEnabled?.reasons}
      compact={compact}
      description={item.description}
      dataModelName={item.dataModelName}
      hasConditions={item.conditionalAccess?.supported}
      key={`search_item_${item.id}`}
      keyword={item.keyword}
      name={item.name}
      newCohort={newCohort}
      newCohortCode={newCohortCode}
      newRequestCode={newRequestCode}
      primaryDictionary={item.primaryDictionary}
      showConditions={showConditions}
      visibility={item.visibility}
    />
  ))
);

const mapStateToProps = ({
  auth: { role: { permissions: { requests, cohorts } } },
  cohorts: { newCohortCode },
  requests: { newRequestCode },
}) => (
  {
    accessRequestAllowed: requests.create,
    cohortAllowed: cohorts.create,
    newCohortCode,
    newRequestCode,
  }
);

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchresultCardItems);
